import { render, staticRenderFns } from "./YearInReview.vue?vue&type=template&id=06f93427&scoped=true"
import script from "./YearInReview.vue?vue&type=script&lang=js"
export * from "./YearInReview.vue?vue&type=script&lang=js"
import style0 from "./YearInReview.vue?vue&type=style&index=0&id=06f93427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f93427",
  null
  
)

export default component.exports